import styles from "./CircleLoader.module.css";

type Props = {
  color?: string
  scale?: number
}
export const CircleLoader = ({ color, scale = 1 }: Props) => (
  <div className="loader initial"></div>
);
